import React, { useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { useNavigate, useLocation } from "react-router-dom";
import AWSManagerSingleton from "../../Utility/AWS/AWSManagerSingleton";

const ForgotPasswordForm = () => {
  const location = useLocation();
  const URLparams = new URLSearchParams(location.search);
  const Username = URLparams.get("username")
    ? decodeURIComponent(URLparams.get("username"))
    : "";

  const [username, setUsername] = useState(Username);
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [code, setCode] = useState("");

  const navigate = useNavigate();
  const awsManager = new AWSManagerSingleton();

  const handleForgot = async () => {
    if (password !== repeatPassword) {
      alert("Le Password non coincidono");
      return;
    }

    try {
      const verificationCode = await awsManager.CognitoResetPassword(
        username,
        password,
        code
      );

      if (verificationCode === 0) {
        alert("Password aggiornata con successo!");
        navigate("/");
      } else if (verificationCode === 1) {
        alert(
          "La Password inserita non rispetta i criteri:\n-Mimimo 8 caratteri\n-Mimimo 1 carattere maiuscolo\n-Minimo 1 carattere minuscolo\n-Minimo 1 carattere speciale"
        );
      } else if (verificationCode === 2) {
        alert(
          "Superato limite massimo di tentativi, riprovare tra un po' di tempo"
        );
      } else if (verificationCode === 3) {
        alert("Codice non corretto");
      }
    } catch (Exception) {
      console.error(Exception);
      alert(Exception);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        background: "rgba(227, 30, 36, 0.9)", // 👈 same red background as login
        padding: "20px",
      }}
    >
      <img
        src="/pms/cannonOrizzontaleBianco.png"
        alt="Cannon"
        style={{ width: "25rem", marginBottom: "1.5rem" }}
      />

      <Card
        style={{
          width: "100%",
          maxWidth: "400px",
          padding: "2rem",
          borderRadius: "1rem",
          boxShadow: "0 8px 24px rgba(227, 30, 36, 0.3)",
          background: "#fff",
          textAlign: "center",
        }}
      >
        <h2 style={{ marginBottom: "1rem" }}>Recupera Password</h2>
        <p style={{ marginBottom: "1.5rem", fontSize: "0.9rem", color: "#555" }}>
          Inserisci il codice ricevuto via email e imposta la nuova password
        </p>

        {/* Username */}
        <div style={{ marginBottom: "1rem" }}>
          <InputText
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Username"
            style={{
              width: "100%",
              padding: "0.75rem",
              borderRadius: "0.5rem",
              border: "1px solid #ccc",
            }}
          />
        </div>

        {/* New Password */}
        <div style={{ marginBottom: "1rem" }}>
          <InputText
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Nuova Password"
            style={{
              width: "100%",
              padding: "0.75rem",
              borderRadius: "0.5rem",
              border: "1px solid #ccc",
            }}
          />
        </div>

        {/* Repeat Password */}
        <div style={{ marginBottom: "1rem" }}>
          <InputText
            id="repeat-password"
            type="password"
            value={repeatPassword}
            onChange={(e) => setRepeatPassword(e.target.value)}
            placeholder="Ripeti Password"
            style={{
              width: "100%",
              padding: "0.75rem",
              borderRadius: "0.5rem",
              border: "1px solid #ccc",
            }}
          />
        </div>

        {/* Verification Code */}
        <div style={{ marginBottom: "1.5rem" }}>
          <InputText
            id="code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="Codice di Verifica"
            style={{
              width: "100%",
              padding: "0.75rem",
              borderRadius: "0.5rem",
              border: "1px solid #ccc",
            }}
          />
        </div>

        {/* Confirm Button */}
        <Button
          label="Conferma"
          onClick={handleForgot}
          style={{
            width: "100%",
            padding: "0.75rem",
            background: "#E31E24",
            border: "none",
            borderRadius: "0.5rem",
            color: "#fff",
            fontWeight: "bold",
            transition: "background 0.3s",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.background = "#C2181C")}
          onMouseLeave={(e) => (e.currentTarget.style.background = "#E31E24")}
        />
      </Card>
    </div>
  );
};

export default ForgotPasswordForm;
